import React from 'react';
import { TranslationKeys } from '../../core/constants/translationKeys';

function FairnessInput({
  text,
  type,
  value,
  isHashCode,
  handleClick,
  t = () => {},
  isShowCopyIcon,
  copiedInputType,
  onChangeHandler = () => {},
  isReadOnly = false,
}) {
  return (
    <div className='cpt-popup-input-parent'>
      <div className='cpt-popup-input-title-container'>
        <label htmlFor='' className='cpt-input-title'>
          {t(text)}
        </label>
      </div>
      <div className={`cpt-popup-input-container ${isShowCopyIcon ? 'with-icon' : ''}`}>
        <input
          type='text'
          value={value || ''}
          className='cpt-popup-input'
          readOnly={isReadOnly}
          onChange={(e) => onChangeHandler(e, type)}
        />
        {isShowCopyIcon && (
          <button
            className={`cpt-input-copy-btn ${
              copiedInputType.some((el) => el.item === type) ? 'show-title' : ''
            }`}
            onClick={() => handleClick(value, type, isHashCode)}
          >
            <i className='icon-copy' />
            <span className='cpt-top-min-hov copy-label'>
              <span className='cpt-top-min-hov-txt'>{t(TranslationKeys.Copied)}</span>
            </span>
          </button>
        )}
      </div>
    </div>
  );
}

export default FairnessInput;
